var Sentry = require('@sentry/browser');

const environmentMapping = {
    'production': 'prod',
    'development': 'dev'
};

Sentry.init({
    dsn: window.sentryDSN,
    release: window.sentryRelease,
    environment: environmentMapping[process.env.NODE_ENV] || 'unknown environment',
});

require('./placeholder-shown.js');
require('./answer-upvote.js');
require('./home-questionform');
require('./modal.js');
require('./show-below-fold.js');
require('./ajax-form');

var ready = require('./ready.js');

ready(function() {
    // Workaround to prevent modal transitions from playing on page load
    // This assumes we never play transitions longer than 1000ms
    setTimeout(function() {
        document.body.classList.remove("loading");
    }, 1000);
})
